import './index.scss';
import React, { Fragment, useEffect, useState } from 'react';
import { NavBar, Icon, Tabs } from 'antd-mobile';
import { detail as getDetail } from '@/services/saas/studio';
import { getBooleanValue } from '@/utils';
import { MyStudioItem } from '@/components/studio/studioItem';
import { StudioInteractList, StudioLive, Resource } from '@/components/studio/list';
import DrawerWrapper from '@/components/drawerWrapper';
import { getApp } from '../../utils';

function StudioDetail(props) {
  const [detail, setDetail] = useState(false);

  const tabList = [
    { title: '教研活动', key: 'jyhd' },
    { title: '名师直播', key: 'mszb' },
    { title: '教研直播', key: 'jyzb' },
    { title: '名师资源', key: 'mszy' },
  ];

  const {
    match: {
      params: { id },
    },
  } = props;

  const getStudioDetail = async () => {
    const response = await getDetail({ studioId: id });
    if (response.success && response.data) {
      setDetail(response.data);
    }
  };

  useEffect(() => {
    getStudioDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { appId } = getApp() || {};

  return (
    <DrawerWrapper>
      <div className={`studioDetail${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}>
        <NavBar
          mode="light"
          icon={<Icon type="left" />}
          onLeftClick={() => window.history.go(-1)}
        >
          <span>{detail.studioName}</span>
        </NavBar>
        <div className="content">
          <div className="detail">
            <MyStudioItem
              status={detail.liveChannelLiveStatus}
              avatar={detail.avatar}
              name={detail.studioName}
              subTitle={[detail.areaName, detail.deptName].join('.')}
              tag={[
                { title: '科目', value: [detail.periodName, detail.subjectName].join('') },
                { title: '成员', value: `${detail.memberCount || 0}` },
                { title: '资源', value: `${detail.resCount || 0}` },
              ]}
            />
          </div>
          <div className="activity-live-res">
            {detail && (
              <Tabs
                tabs={tabList}
                tabBarPosition="top"
                tabBarUnderlineStyle={{
                  width: '3.73vw',
                  height: '0.8vw',
                  background: '#00A4FF',
                  borderRadius: '1vw',
                  marginLeft: '9.87vw',
                }}
                tabBarActiveTextColor="#333333"
                tabBarInactiveTextColor="#8E8E8E"
                tabBarTextStyle={{
                  fontSize: '4vw',
                  fontFamily: 'PingFang SC',
                  fontWeight: 500,
                }}
                animated={false}
                swipeable={false}
                useOnPan={false}
              >
                <Fragment key="jyhd">
                  <StudioInteractList sourceApp={appId} studioId={detail.studioId} studioType={detail.studioType} />
                </Fragment>
                <Fragment key="mszb">
                  <StudioLive
                    type="liveChannel"
                    studioId={detail.studioId}
                    studioType={detail.studioType}
                    liveChannelId={detail.liveChannelId}
                    sourceApp={appId}
                  />
                </Fragment>
                <Fragment key="jyzb">
                  <StudioLive
                    type="lesson"
                    studioId={detail.studioId}
                    studioType={detail.studioType}
                    sourceApp={appId}
                  />
                </Fragment>
                <Fragment key="mszy">
                  <Resource
                    sourceApp={appId}
                    studioId={detail.studioId}
                    studioType={detail.studioType}
                  />
                </Fragment>
              </Tabs>
            )}
          </div>
        </div>
      </div>
    </DrawerWrapper>
  );
}

export default StudioDetail;
